<div class="action-container-header-wrapper">
  <div class="floori-action-container-header-title">
    @if (icon()) {
      <floori-icon class="primary" [name]="icon()"></floori-icon>
    }
    <p class="bold">{{ title() }}</p>
  </div>

  <div class="floori-action-container-header-actions">
    @if (showSelector()) {
      <button
        floori-button
        class="small outline sizes-dialog-handler"
        (click)="selectorClickHandler()">
        {{ selectorValue() }}
      </button>
    }

    <ng-content></ng-content>

    @if (headerType() === 'addToCart') {
      <div
        class="info-container prevent-select"
        flooriTooltip="room.selectedProducts.tooltipLabel"
        [isMobile]="isMobile()"
        [isMobileBySize]="isMobileBySize()"
        [tooltipWidth]="250"
        [tooltipOnMobile]="true"
        #infoContainerRef>
        <floori-icon class="primary" name="fl_info_o"></floori-icon>
      </div>
    }

    @if (primaryButton()?.display) {
      <button
        floori-icon-button
        class="small outline remove-product-handler"
        [ngClass]="{ notification: primaryButton()?.notification }"
        (click)="primaryButtonClickHandler()">
        <floori-icon [name]="primaryButton()?.icon || ''"></floori-icon>
      </button>
      } @if (secondaryButton()?.display) {
      <button
        floori-icon-button
        class="small outline remove-product-handler"
        [ngClass]="{ notification: secondaryButton()?.notification }"
        (click)="secondaryButtonClickHandler()">
        <floori-icon [name]="secondaryButton()?.icon || ''"></floori-icon>
      </button>
      } @if (tertiaryButton()?.display) {
      <button
        floori-icon-button
        class="small outline remove-product-handler"
        [ngClass]="{ notification: tertiaryButton()?.notification }"
        (click)="tertiaryButtonClickHandler()">
        <floori-icon [name]="tertiaryButton()?.icon || ''"></floori-icon>
      </button>
      } @if (showCloseButton()) {
      <button
        floori-icon-button
        class="small outline no-border close-handler"
        (click)="closeHandler()">
        <floori-icon name="fl_close"></floori-icon>
      </button>
    }
  </div>
</div>

@if (message()) {
  <div class="feature-message-mobile">{{ message() }}</div>
}
